import { Modal } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import {useSelector } from "react-redux";

export default function ModalDeleteConfirm({ handleDelete }) {
  const { profile } = useSelector(({ profile }) => profile);
  

  const showModal = () => {
    Modal.confirm({
      title: "Confirm",
      icon: <ExclamationCircleOutlined />,
      content: "Are you sure to delete?",
      okText: "Yes",
      cancelText: "No",
      onOk: handleDelete,
    });
  };
 
  return <div onClick={showModal}>Delete</div>;
}

ModalDeleteConfirm.propTypes = {
  onCancel: PropTypes.func.isRequired,
};
